import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";

export default function Login() {
  const nav = useNavigate();
  const loc = useLocation();
  const next = loc.state?.next || "/test";
  const { login } = useAuth();
  const [form, setForm] = useState({ email: "", password: "", remember: true });
  const [show, setShow] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(form.email.trim().toLowerCase(), form.password, form.remember);
      toast.success("Tekrar hoş geldin!");
      nav(next);
    } catch (e2) {
      const d = e2?.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Giriş başarısız.");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto" data-testid="login-page">
      <h1 className="text-4xl md:text-5xl font-semibold tracking-tight h-gradient">Giriş Yap</h1>
      <p className="mt-4 text-neutral-400">Hesabına giriş yap ve kaldığın yerden devam et.</p>

      <form onSubmit={submit} className="glass mt-8 p-8 space-y-6">
        <div>
          <label className="text-xs uppercase tracking-[0.15em] text-neutral-500">E-posta</label>
          <input type="email" autoCapitalize="off" autoCorrect="off" spellCheck={false} className="life-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="ornek@mail.com" data-testid="login-email" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-[0.15em] text-neutral-500">Şifre</label>
          <div className="relative">
            <input type={show ? "text" : "password"} autoCapitalize="off" autoCorrect="off" spellCheck={false} className="life-input pr-10" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="login-password" />
            <button type="button" onClick={() => setShow(s => !s)} className="absolute right-1 top-1/2 -translate-y-1/2 text-neutral-500 hover:text-white p-1">
              {show ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>
        </div>
        <label className="flex items-center gap-2 text-sm text-neutral-300 cursor-pointer">
          <input type="checkbox" checked={form.remember} onChange={(e) => setForm({ ...form, remember: e.target.checked })} data-testid="login-remember" />
          Beni hatırla (30 gün)
        </label>
        {err && <div className="text-sm text-red-300/80" data-testid="login-error">{err}</div>}
        <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="login-submit">
          {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
        </button>
        <p className="text-xs text-neutral-500 text-center">
          Henüz hesabın yok mu? <Link to="/kayit" state={{ next }} className="text-white underline" data-testid="goto-register">Hesap Oluştur</Link>
        </p>
      </form>
    </div>
  );
}
